import { apiDepartments } from "@/api/department.api.ts";
import useFormatter from "@/hooks/use-formatter.hook.ts";
import { ApiDepartmentsChartFilter } from "@/pages/employees/departments-chart/departments-chart.types.ts";
import { ApiDepartment, DepartmentNodeMode } from "@/types/department.types.ts";
import { useTranslation } from "react-i18next";

export default function useDepartmentsChartHook() {
  const { t } = useTranslation();
  const { renderEmployeeName } = useFormatter();

  const renderCaption = (department: ApiDepartment): string => {
    const nameManager = department.manager ? `${renderEmployeeName(department.manager)}` : "";

    return `${nameManager}`;
  };

  const renderExtra = (department: ApiDepartment): string => {
    const employeesCount = `${t("plurals:employees_count", { count: department.employees_count })}`;

    return `${employeesCount}`;
  };

  const loadDepartmentsChart = async (
    departmentId: number | undefined,
    filter: ApiDepartmentsChartFilter,
    mode: DepartmentNodeMode = DepartmentNodeMode.children
  ) => {
    const { data: departments } = await apiDepartments.chart(departmentId, mode, filter);

    return departments;
  };

  const loadDepartmentsChartByNodeId = async (
    nodeId: string | undefined,
    filter: ApiDepartmentsChartFilter,
    mode: DepartmentNodeMode = DepartmentNodeMode.children
  ): Promise<ApiDepartment[]> => {
    if (!nodeId) return [];
    if (nodeId == "root") return [];

    const id = Number(nodeId);

    const departments = await loadDepartmentsChart(id, filter, mode);

    return departments ?? [];
  };

  return {
    renderExtra,
    renderCaption,
    loadDepartmentsChart,
    loadDepartmentsChartByNodeId,
  };
}
